document.addEventListener('DOMContentLoaded', function() {
  var megaMenus = document.querySelectorAll('.mega-menu');

  megaMenus.forEach(function(menu) {
    var summary = menu.querySelector('summary');

    // When hovering in, open this menu and close others that aren’t locked.
    menu.addEventListener('mouseenter', function() {
      megaMenus.forEach(function(otherMenu) {
        if (otherMenu !== menu) {
          otherMenu.removeAttribute('open');
        }
      });
      menu.setAttribute('open', '');
    });

    // When leaving, check if the new target is inside this menu.
    menu.addEventListener('mouseleave', function(e) {
      // If the element we’re moving to is not a descendant of this menu, and it’s not locked, then close.
      if (!menu.contains(e.relatedTarget) && !menu.classList.contains('locked')) {
        menu.removeAttribute('open');
      }
    });

  });
});
